import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { IGrantPipelineStage } from '../../../../../../../../types'
import { GrantsTable } from '../../../../sharedComponents'

interface ListViewProps {
  fetchGrants: () => void
  pipelineStages: IGrantPipelineStage[]
  pipelineData: Record<string, { grants: any[]; totalAmount: number }>
}

const Table_Headers = ['Grant Name', 'Funding Agency', 'Amount', 'Type', 'Due Date', 'Status']

export const ListView: FC<ListViewProps> = ({ pipelineData, pipelineStages, fetchGrants }) => {
  const { projectId = '' } = useParams()

  return (
    <Box>
      {pipelineData && pipelineStages.map(({ stage }) => {
        const grants = pipelineData[stage]?.grants || []
        return (
          <Box my={1}>
            <Stack direction='row' mb={1.5} gap={0.6}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: '0.9rem',
                  color: 'secondary',
                  textTransform: 'capitalize',
                }}
              >
                {stage}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '1rem',
                  color: "secondary",
                }}
              >
                {`${grants.length} ($${pipelineData[stage]?.totalAmount.toLocaleString('en-US') || 0})`}
              </Typography>

            </Stack>

            <GrantsTable
              currentTab="Pipeline"
              projectId={projectId}
              fetchGrants={fetchGrants}
              tableHeader={Table_Headers}
              grants={grants}
            />
          </Box>
        )
      })}
    </Box>
  )
}
